module.exports = __webpack_public_path__ + "img/Glocal.7d07e64d.6845c0ca.webp";